import {
  type EdgeData,
  type EdgeId,
  type NodeData,
  isNonNullable,
  isPathLookupEdgeData,
  isPathLookupNodeData,
} from '@ipfabric/utils';

export const getFollowingPacketIds = (
  packetId: EdgeId,
  edgeData?: EdgeData,
  nodeData?: NodeData,
): EdgeId[] | null => {
  if (edgeData !== undefined && isPathLookupEdgeData(edgeData)) {
    return edgeData.nextEdgeIds;
  }
  if (
    nodeData !== undefined &&
    isPathLookupNodeData(nodeData) &&
    isNonNullable(nodeData.generatedPackets?.[packetId]?.nextEdgeIds)
  ) {
    // Fixed noUncheckedIndexedAccess NIM-19408
    return nodeData.generatedPackets![packetId]!.nextEdgeIds;
  }
  return null;
};
